import type { SessionUser } from '@/entities/session/types'
import {
  FIXTURE_USER_DOCTOR_ID,
  FIXTURE_USER_SYSTEM_ADMIN_ID,
} from '@/shared/screenshotSeed/synapScreenshotFixtures'
import type { SynapScreenshotPersona } from '@/shared/lib/screenshotMode'

export function buildScreenshotFixtureSessionUser(persona: SynapScreenshotPersona): SessionUser {
  const isAdmin = persona === 'system_admin'
  const id = isAdmin ? FIXTURE_USER_SYSTEM_ADMIN_ID : FIXTURE_USER_DOCTOR_ID
  return {
    id,
    name: isAdmin ? 'Admin Synap (mock)' : 'Dra. Helena Synap (mock)',
    email: isAdmin ? 'admin.mock@synap.invalid' : 'medica.mock@synap.invalid',
    role: 'doctor',
    crm: 'CRM-SP 123456',
    specialties: ['Clínica médica', 'Medicina de família'],
    phone1: '(11) 99999-0001',
    isSystemAdmin: isAdmin,
    onboardingCompleted: true,
    onboardingWelcomeSeen: true,
    emailConfirmed: true,
    printName: isAdmin ? 'Synap Admin Mock' : 'Helena Synap',
    especialidades: ['Clínica médica', 'Medicina de família'],
    telefone1: '(11) 99999-0001',
  }
}
